import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";

const useStyles = textAlign => makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    labelDiv: {
        gap: theme.spacing(),
        display: 'flex',
        alignItems: 'center'
    },
    endIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '0.35em'
    },
    labelTypography: {
        color: theme.palette.secondary.dark,
        textTransform: 'uppercase',
        textAlign,
        width: textAlign === 'center' ? '100%' : 'initial'
    },
    valueTypography: {
        textAlign
    }
}));

export default function LabelValue(props) {
    const {
        label,
        value,
        children,
        textAlign = 'left',
        endIcon = null,
        className = ''
    } = props;
    const classes = useStyles(textAlign)();

    return (
        <div className={clsx(classes.root, className)}>
            <div className={classes.labelDiv}>
                <Typography display="block" className={classes.labelTypography} gutterBottom>
                    {label}
                </Typography>
                {endIcon &&
                    <div className={classes.endIcon}>
                        {endIcon}
                    </div>
                }
            </div>
            {value ? (
                <Typography variant="body1" className={classes.valueTypography}>
                    {value}
                </Typography>
            ) : children}
        </div>
    );
};

LabelValue.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    textAlign: PropTypes.oneOf([ 'left', 'center', 'right' ]),
    className: PropTypes.string
};